export default __webpack_public_path__ + "static/media/EV-station.35bfeb14.png";